import { render, staticRenderFns } from "./EmailTemplatesTab.vue?vue&type=template&id=722f3520"
import script from "./EmailTemplatesTab.vue?vue&type=script&lang=js"
export * from "./EmailTemplatesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports